import { Flex, Icon, Link, LinkProps, Text } from '@bitrise/bitkit';
import React, { ReactNode, useContext, FunctionComponent } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { URLStateContext } from '../URLState/URLState';

interface Props extends LinkProps {
  children: ReactNode;
  to?: string;
}

const PageBreadcrumb: FunctionComponent<Props> = (props) => {
  const { children, to, ...rest } = props;
  const { to: createTo } = useContext(URLStateContext);

  if (!to) {
    return <Text>{children}</Text>;
  }

  return (
    <Flex direction="horizontal" margin="x3">
      <Link
        {...rest}
        Component={RouterLink}
        clickable
        color="grape-5"
        margin="x1"
        to={createTo(to)}
      >
        <Flex alignChildrenVertical="middle" direction="horizontal" gap="x2">
          <Flex>
            <Icon name="ArrowBack" />
          </Flex>

          <Flex>
            <Text>{children}</Text>
          </Flex>
        </Flex>
      </Link>
    </Flex>
  );
};

export default PageBreadcrumb;
